//import Vue from 'vue'
import _ from 'lodash/lodash.min.js'

const state = {
    authProfile: {}
}

const getters = {
    FullName: (state) => {
        //if (state.authProfile || state.authProfile.name) {
        if (_.has(state.authProfile, 'name')) {
            return state.authProfile.name
        }
        return null
    }
}

const actions = {
    getProfile (context) {
        return new Promise((resolve, reject) => {
            var profile = localStorage.getItem('profile')
            context.commit('setProfile', JSON.parse(localStorage.getItem('profile')))
            resolve(profile)
        })
    }
}

const mutations = {
    setProfile (state, profile) {
        state.authProfile = profile
    }
}

export default {
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
}
